import React from 'react';
import { keyMessages } from '../data/messages';
export function MessageBand() {
  return <div className="border-y border-champagne bg-cream-light px-4 py-5" data-id="element-141" data-mp="f19fpy2i6bfo">
      <ul className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-bold uppercase tracking-[0.14em] text-espresso sm:text-[13px]" data-id="element-142" data-mp="f45c3hypcs20">
        {keyMessages.map((message, index) => <li key={message} className="flex items-center gap-4" data-id="element-143" data-mp="12rwp6ns2h94c" data-mpi={index}>
            {index > 0 && <span className="text-champagne-deep" aria-hidden="true" data-id="element-144" data-mp="xsk0ryljrtzn">
                ✦
              </span>}
            <span className={message === '100% Visual' || message.startsWith('6-in-1') ? 'text-raspberry' : ''} data-id="element-145" data-mp="t0ijtzdfpf3a">
              {message}
            </span>
          </li>)}
      </ul>
    </div>;
}